// Khung đo lường CHẠY (ARCHITECTURE §6.2). Không phụ thuộc React/mạng —
// chỉ gom số đo trong RAM; ai muốn gửi lên DB thì gọi flush() từ src/api.
// Chạy ngầm, LỖI THÌ IM (không được làm vỡ UI vì đo lường).

export type NhomManHinh = "dang_nhap" | "khoi_dong" | "lop" | "classplan" | "kehoach" | "nghiday" | "tacvu" | "nguonluc" | "thongtin" | "caidat" | "kho-ui";

export interface DiemDo {
  luc: number; // performance.now() lúc ghi
  man_hinh: NhomManHinh;
  buoc: string; // "ttfb" | "fcp" | "lcp" | "rpc_bootstrap" | "engine" | "ve" | "loc" | "sort" | "luu_lop" | ...
  ms: number;
  so_dong?: number;
  byte?: number;
  cache_hit?: boolean;
}

const diem_do_gan_nhat: DiemDo[] = [];
const GIOI_HAN = 200; // chỉ giữ N điểm gần nhất trong RAM (nút ⏱ chỉ cần "lần mở gần nhất")

export function ghiDiemDo(d: Omit<DiemDo, "luc">): void {
  try {
    diem_do_gan_nhat.push({ ...d, luc: performance.now() });
    if (diem_do_gan_nhat.length > GIOI_HAN) diem_do_gan_nhat.shift();
  } catch {
    // đo lường không bao giờ được làm vỡ luồng chính
  }
}

export function layDiemDoGanNhat(): readonly DiemDo[] {
  return diem_do_gan_nhat;
}

// Bọc 1 thao tác bất đồng bộ, tự đo ms bắt đầu -> kết thúc (kể cả khi lỗi).
export async function doThoiGian<T>(
  man_hinh: NhomManHinh,
  buoc: string,
  viec: () => Promise<T>,
): Promise<T> {
  const bat_dau = performance.now();
  try {
    return await viec();
  } finally {
    try {
      ghiDiemDo({ man_hinh, buoc, ms: performance.now() - bat_dau });
    } catch {
      // im lặng theo đúng luật §6.2
    }
  }
}

// Đo TTFB/FCP/LCP mở trang — gọi 1 lần lúc app khởi động (main.tsx).
export function ganPerformanceObserver(): void {
  try {
    const nav = performance.getEntriesByType("navigation")[0] as
      | PerformanceNavigationTiming
      | undefined;
    if (nav) {
      ghiDiemDo({
        man_hinh: "khoi_dong",
        buoc: "ttfb",
        ms: nav.responseStart - nav.requestStart,
      });
    }

    const po = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.name === "first-contentful-paint") {
          ghiDiemDo({ man_hinh: "khoi_dong", buoc: "fcp", ms: entry.startTime });
        }
      }
    });
    po.observe({ type: "paint", buffered: true });

    const poLcp = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const cuoi = entries[entries.length - 1];
      if (cuoi) ghiDiemDo({ man_hinh: "khoi_dong", buoc: "lcp", ms: cuoi.startTime });
    });
    poLcp.observe({ type: "largest-contentful-paint", buffered: true });
  } catch {
    // trình duyệt không hỗ trợ PerformanceObserver -> bỏ qua, không phải lỗi
  }
}
